module.exports = __webpack_public_path__ + "img/4-2_Sample_DataView_2.0ac4ecea.png";